import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Ticket Status Change Trigger Actions.
 *
 * Perechile vechi: `settings/easeedesk/ticket_status_change_trigger_actions`,
 * `getTicketStatusChangeTriggerActions`, `create_status_change_trigger_actions`,
 * `edit_action_tab`, `edit_action_trigger_save`,
 * `delete_status_change_trigger_actions`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface StatusTriggerRow {
  id: number
  company_id: number
  company_name: string
  ticket_type_id: number
  ticket_type_name: string
  ticket_status_id: number
  ticket_status_name: string
  ticket_status_color: string
  action: string
  action_data: string
  created_at: string
  updated_at: string
  DT_RowId: string
}

export interface StatusTriggersTablePage {
  draw: number
  recordsTotal: number
  recordsFiltered: number
  data: StatusTriggerRow[]
}

export interface StatusTriggersShell {
  title: string
  moduleUrl: string
  companies: { ID: number; name: string }[]
  ticket_types: { ID: number; type_name: string; short_name: string }[]
  statuses: { ID: number; status_name: string }[]
}

export interface StatusTriggerDetails {
  id: number
  company_id: number
  ticket_type_id: number
  ticket_status_id: number
  action: string
  action_data: string
}

export interface StatusTriggersTableRequest {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderName: string
  orderDir: 'asc' | 'desc'
  search: string
}

/** Aceiasi parametri pe care ii trimitea DataTables pe `getTicketStatusChangeTriggerActions`. */
export function statusTriggersTableParams(r: StatusTriggersTableRequest): URLSearchParams {
  const p = new URLSearchParams()
  p.set('draw', String(r.draw))
  p.set('start', String(r.start))
  p.set('length', String(r.length))
  p.set('order[0][column]', String(r.orderColumn))
  p.set('order[0][dir]', r.orderDir)
  p.set(`columns[${r.orderColumn}][name]`, r.orderName)
  p.set('search[value]', r.search)
  return p
}

export function statusTriggersShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'status_triggers'],
    queryFn: () => apiGet<StatusTriggersShell>('/settings/easeedesk/ticket_status_change_trigger_actions'),
  })
}

export function statusTriggersTableQuery(r: StatusTriggersTableRequest) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'status_triggers', 'table', r],
    queryFn: () =>
      apiGet<StatusTriggersTablePage>(
        `/settings/easeedesk/ticket_status_change_trigger_actions/table?${statusTriggersTableParams(r).toString()}`,
      ),
  })
}

export function statusTriggerQuery(id: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'status_triggers', 'one', id],
    queryFn: () => apiGet<StatusTriggerDetails>(`/settings/easeedesk/ticket_status_change_trigger_actions/${id}`),
    enabled: id > 0,
  })
}

export interface StatusTriggerFields {
  company: number
  ticket_types: number
  ticket_status: number
  action: string
  action_data: string
}

export function createStatusTrigger(fields: StatusTriggerFields) {
  return apiPost<{ ok?: boolean; id?: number }>('/settings/easeedesk/ticket_status_change_trigger_actions', {
    ...fields,
  })
}

export function updateStatusTrigger(id: number, fields: StatusTriggerFields) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_status_change_trigger_actions/${id}`, { ...fields })
}

export function removeStatusTrigger(id: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_status_change_trigger_actions/${id}/remove`, {})
}
